import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../components/Loader';
import ViewFailedPayout from '../../../components/siteadmin/ViewFailedPayout/ViewFailedPayout';

import getFailedTransaction from './getFailedTransaction.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './FailedPayout.css';

const FailedPayout = (props) => {

    const { data: { loading, getFailedTransaction }, title } = props;

    if (loading) {
        return <Loader type={"text"} />
    }
    return <ViewFailedPayout
        data={getFailedTransaction}
        title={title}
    />
}

FailedPayout.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getFailedTransaction: PropTypes.array
    })
}

export default compose(
    withStyles(s),
    withQuery(getFailedTransaction,
        {
            options: (props) => ({
                variables: {
                    id: props.id
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }
    )
)(FailedPayout);